export default __webpack_public_path__ + "images/0x56192e94434c4fd3278b4fa53039293fb00de3db.png";